import React from 'react';
import styled from 'styled-components/macro';
import MuiInputLabel from '@material-ui/core/InputLabel';
import { TextString } from './Text';

const StyledInputLabel = styled(MuiInputLabel)`
  && {
    font-size: 14px;
  }
`;
export default function InputLabel(props) {
  return (
    <StyledInputLabel {...props}>
      {typeof props.content === 'string' ? (
        <TextString content={props.content} />
      ) : (
        props.content
      )}
    </StyledInputLabel>
  );
}
